function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { DEFAULT_DATE_FORMAT, DetailToGranularityMap, TIMETYPE, TIME_VALUE_INTERVAL_MAP } from './constants';
export var DateValidator =
// dateSeparator;
function DateValidator(format, momentGenerator, rangeConnecterFormat, _granularity, maxDetail) {
  var _this = this;
  if (format === void 0) {
    format = DEFAULT_DATE_FORMAT;
  }
  if (rangeConnecterFormat === void 0) {
    rangeConnecterFormat = 'to';
  }
  this.momentUtils = void 0;
  this.rangeConnecterFormat = void 0;
  this.format = void 0;
  this.singleDateStringLength = void 0;
  this.rangeDateStringLength = void 0;
  this.maxDetail = void 0;
  this.isSameDates = function (date1, date2, unit) {
    if (unit === void 0) {
      unit = 'day';
    }
    if (!date1 || !date2) {
      return date1 === date2;
    }
    var isSame = _this.momentUtils.isSame;
    if (Object.getPrototypeOf(date1) === Object.getPrototypeOf(date2)) {
      if (date1 instanceof Array && date2 instanceof Array) {
        return isSame(date1[0], date2[0], unit) && isSame(date1[1], date2[1], unit);
      } else if (date1 instanceof Date && date2 instanceof Date) {
        return isSame(date1, date2, unit);
      } else {
        return false;
      }
    } else {
      return false;
    }
  };
  this.isValidFormatDateString = function (dateString) {
    if (dateString === '') {
      return true;
    }
    var isRange = dateString.length === _this.rangeDateStringLength;
    var isSingle = dateString.length === _this.singleDateStringLength;
    if (isRange) {
      return _this._isValidFormatRangeDate(dateString);
    } else if (isSingle) {
      return _this._isValidFormatSingleDate(dateString);
    } else {
      return false;
    }
  };
  this.isValidDateValueByRules = function (args) {
    var date = args.date,
      disabledRanges = args.disabledRanges,
      disabledDates = args.disabledDates,
      minDate = args.minDate,
      maxDate = args.maxDate;
    var _this$momentUtils = _this.momentUtils,
      addDate = _this$momentUtils.addDate,
      subtractDate = _this$momentUtils.subtractDate;
    if (date === undefined) {
      return true;
    }
    if (date === null) {
      return false;
    }
    if (date === '') {
      return true;
    }
    if (!disabledRanges) disabledRanges = [];
    if (!disabledDates) disabledDates = [];
    //8640000000000000 is the max/min value Date Object support;
    var maxDateInterval = maxDate ? [addDate(maxDate, 1, 'day'), new Date(8640000000000000)] : [];
    var minDateInterval = minDate ? [subtractDate(minDate, 1, 'day'), new Date(-8640000000000000)] : [];
    var disabledDatesIntervals = [].concat(disabledDates.map(function (date) {
      return [date, date];
    }), disabledRanges, [maxDateInterval, minDateInterval]);
    var mergedDisabledDatesIntervals = _this.mergeDisabledDatesIntervals(disabledDatesIntervals, DetailToGranularityMap.get(_this.maxDetail));
    if (typeof date === 'string') {
      if (date.length === _this.singleDateStringLength) {
        return _this.isValidSingleDateByRules(args, mergedDisabledDatesIntervals);
      } else if (date.length === _this.rangeDateStringLength) {
        return _this.isValidRangeDateByRules(args, mergedDisabledDatesIntervals);
      } else {
        return false;
      }
    }
    if (date instanceof Date) {
      return _this.isValidSingleDateByRules(args, mergedDisabledDatesIntervals);
    }
    if (date instanceof Array) {
      if (date.length === 0) return true;
      if (date.length === 1) {
        args.date = date[0];
        return _this.isValidSingleDateByRules(args, mergedDisabledDatesIntervals);
      } else {
        return _this.isValidRangeDateByRules(args, mergedDisabledDatesIntervals);
      }
    }
    return true;
  };
  this.mergeDisabledDatesIntervals = function (intervals, granularity) {
    var _this$momentUtils2 = _this.momentUtils,
      diff = _this$momentUtils2.diff,
      getStartDate = _this$momentUtils2.getStartDate,
      getEndDate = _this$momentUtils2.getEndDate;
    if (intervals.length === 0 || intervals.every(function (subArr) {
      return subArr.length === 0;
    })) {
      return [];
    }
    if (granularity === 'month') {
      var newIntervals = [];
      for (var _iterator = _createForOfIteratorHelperLoose(intervals), _step; !(_step = _iterator()).done;) {
        var interval = _step.value;
        newIntervals.push([getStartDate(interval[0], 'month'), getEndDate(interval[1], 'month')]);
      }
      intervals = newIntervals;
    }
    intervals.sort(function (a, b) {
      return diff(b[0], a[0], 'day');
    });
    var mergedIntervals = [];
    for (var i = 0; i < intervals.length; i++) {
      var L = intervals[i][0],
        R = intervals[i][1];
      if (mergedIntervals.length === 0 ||
      //here should be one rather than 0,
      //because we need to merge single day intervals together
      diff(mergedIntervals[mergedIntervals.length - 1][1], L, 'day') > 1) {
        mergedIntervals.push([L, R]);
      } else {
        mergedIntervals[mergedIntervals.length - 1][1] = diff(mergedIntervals[mergedIntervals.length - 1][1], R, 'day') > 0 ? R : mergedIntervals[mergedIntervals.length - 1][1];
      }
    }
    return mergedIntervals;
  };
  this.isValidRangeDateByRules = function (args, mergedDisabledDatesIntervals) {
    var date = args.date,
      minDate = args.minDate,
      maxDate = args.maxDate,
      disabledDates = args.disabledDates,
      disabledDays = args.disabledDays,
      disabledRanges = args.disabledRanges;
    if (date === undefined) {
      return true;
    }
    if (date === null) {
      return false;
    }
    if (!Array.isArray(date)) {
      return false;
    }
    var valueFrom = null,
      valueTo = null;
    var isDayInRange = _this.isDayInRange,
      isDayExcluded = _this.isDayExcluded,
      momentUtils = _this.momentUtils,
      isMonthInRange = _this.isMonthInRange,
      isYearInRange = _this.isYearInRange,
      isMonthExcluded = _this.isMonthExcluded,
      isYearExcluded = _this.isYearExcluded;
    var getDate = momentUtils.getDate,
      isSameOrBefore = momentUtils.isSameOrBefore;
    if (typeof date === 'string') {
      if (date === '') return true;
      if (!_this._isValidFormatRangeDate(date)) {
        return false;
      }
      var _this$_getSeperateDat = _this._getSeperateDateStringFromRangeDateString(date),
        valueFromStr = _this$_getSeperateDat[0],
        valueToStr = _this$_getSeperateDat[1];
      valueFrom = getDate(valueFromStr);
      valueTo = getDate(valueToStr);
    } else {
      valueFrom = date[0] || null;
      valueTo = date[1] || null;
    }
    switch (_this.maxDetail) {
      case 'month':
        return isDayInRange(valueFrom, minDate, maxDate) && !isDayExcluded(valueFrom, {
          disabledDates: disabledDates,
          disabledDays: disabledDays,
          disabledRanges: disabledRanges
        }) && isDayInRange(valueTo, minDate, maxDate) && !isDayExcluded(valueTo, {
          disabledDates: disabledDates,
          disabledDays: disabledDays,
          disabledRanges: disabledRanges
        }) && isSameOrBefore(valueFrom, valueTo);
      case 'year':
        return isMonthInRange(valueFrom, minDate, maxDate) && !isMonthExcluded(valueFrom, mergedDisabledDatesIntervals) && isMonthInRange(valueTo, minDate, maxDate) && !isMonthExcluded(valueTo, mergedDisabledDatesIntervals) && isSameOrBefore(valueFrom, valueTo);
      case 'decade':
        return isYearInRange(valueFrom, minDate, maxDate) && !isYearExcluded(valueFrom, mergedDisabledDatesIntervals) && isYearInRange(valueTo, minDate, maxDate) && !isYearExcluded(valueTo, mergedDisabledDatesIntervals) && isSameOrBefore(valueFrom, valueTo);
      default:
        return isDayInRange(valueFrom, minDate, maxDate) && !isDayExcluded(valueFrom, {
          disabledDates: disabledDates,
          disabledDays: disabledDays,
          disabledRanges: disabledRanges
        }) && isDayInRange(valueTo, minDate, maxDate) && !isDayExcluded(valueTo, {
          disabledDates: disabledDates,
          disabledDays: disabledDays,
          disabledRanges: disabledRanges
        }) && isSameOrBefore(valueFrom, valueTo);
    }
  };
  this.isValidSingleDateByRules = function (args, mergedDisabledDatesIntervals) {
    var date = args.date,
      minDate = args.minDate,
      maxDate = args.maxDate,
      disabledDates = args.disabledDates,
      disabledDays = args.disabledDays,
      disabledRanges = args.disabledRanges;
    if (Array.isArray(date)) {
      return false;
    }
    if (date === undefined) {
      return true;
    }
    if (typeof date === 'string' && date === '') {
      return true;
    }
    if (typeof date === 'string' && !_this._isValidFormatSingleDate(date)) {
      return false;
    }
    var isDayInRange = _this.isDayInRange,
      isDayExcluded = _this.isDayExcluded,
      isMonthInRange = _this.isMonthInRange,
      isMonthExcluded = _this.isMonthExcluded,
      isYearInRange = _this.isYearInRange,
      isYearExcluded = _this.isYearExcluded;
    var getDate = _this.momentUtils.getDate;
    var currentDate = getDate(date);
    switch (_this.maxDetail) {
      case 'month':
        return isDayInRange(currentDate, minDate, maxDate) && !isDayExcluded(currentDate, {
          disabledDates: disabledDates,
          disabledDays: disabledDays,
          disabledRanges: disabledRanges
        });
      case 'year':
        return isMonthInRange(currentDate, minDate, maxDate) && !isMonthExcluded(currentDate, mergedDisabledDatesIntervals);
      case 'decade':
        return isYearInRange(currentDate, minDate, maxDate) && !isYearExcluded(currentDate, mergedDisabledDatesIntervals);
      default:
        return isDayInRange(currentDate, minDate, maxDate) && !isDayExcluded(currentDate, {
          disabledDates: disabledDates,
          disabledDays: disabledDays,
          disabledRanges: disabledRanges
        });
    }
  };
  this.isDayInRange = function (date, minDate, maxDate, granularity, openInterval) {
    if (granularity === void 0) {
      granularity = 'day';
    }
    if (openInterval === void 0) {
      openInterval = true;
    }
    if (!openInterval) {
      if (!minDate || !maxDate) return false;
    }
    var inRange = true;
    var _this$momentUtils3 = _this.momentUtils,
      isSameOrBefore = _this$momentUtils3.isSameOrBefore,
      isSameOrAfter = _this$momentUtils3.isSameOrAfter;
    if (minDate && maxDate) {
      inRange = isSameOrAfter(date, minDate, granularity) && isSameOrBefore(date, maxDate, granularity);
    } else if (minDate) {
      inRange = isSameOrAfter(date, minDate, granularity);
    } else if (maxDate) {
      inRange = isSameOrBefore(date, maxDate, granularity);
    }
    return inRange;
  };
  this.isDayExcluded = function (day, _temp) {
    var _ref = _temp === void 0 ? {} : _temp,
      disabledDates = _ref.disabledDates,
      disabledDays = _ref.disabledDays,
      disabledRanges = _ref.disabledRanges;
    var _this$momentUtils4 = _this.momentUtils,
      isSame = _this$momentUtils4.isSame,
      isSameOrAfter = _this$momentUtils4.isSameOrAfter,
      isSameOrBefore = _this$momentUtils4.isSameOrBefore,
      getWeekDay = _this$momentUtils4.getWeekDay;
    var isInDisabledDates = disabledDates ? disabledDates.some(function (excludeDate) {
      return isSame(day, excludeDate);
    }) : false;
    var isIndisabledRanges = false;
    if (disabledRanges) {
      for (var _iterator2 = _createForOfIteratorHelperLoose(disabledRanges), _step2; !(_step2 = _iterator2()).done;) {
        var range = _step2.value;
        if (isSameOrAfter(day, range[0]) && isSameOrBefore(day, range[1])) {
          isIndisabledRanges = true;
          break;
        }
      }
    }
    var isInDisabledDays = disabledDays ? disabledDays.indexOf(getWeekDay(day)) !== -1 : false;
    return isInDisabledDates || isInDisabledDays || isIndisabledRanges;
  };
  this.isMonthInRange = function (date, minDate, maxDate) {
    return _this.calcMonthYearInRange(date, minDate, maxDate, 'month');
  };
  this.isYearInRange = function (date, minDate, maxDate) {
    return _this.calcMonthYearInRange(date, minDate, maxDate, 'year');
  };
  this.calcMonthYearInRange = function (value, minDate, maxDate, granularity) {
    var _this$momentUtils5 = _this.momentUtils,
      isSameOrAfter = _this$momentUtils5.isSameOrAfter,
      isSameOrBefore = _this$momentUtils5.isSameOrBefore,
      getStartDate = _this$momentUtils5.getStartDate,
      getEndDate = _this$momentUtils5.getEndDate;
    var inRange = true;
    var valueStart = getStartDate(value, granularity);
    var valueEnd = getEndDate(value, granularity);
    if (minDate && maxDate) {
      inRange = isSameOrAfter(valueStart, minDate, granularity) && isSameOrBefore(valueEnd, maxDate, granularity);
    } else if (minDate) {
      inRange = isSameOrAfter(valueStart, minDate, granularity);
    } else if (maxDate) {
      inRange = isSameOrBefore(valueEnd, maxDate, granularity);
    }
    return inRange;
  };
  this.isMonthExcluded = function (month, mergedDisabledDatesIntervals) {
    return _this.calcYearMonthExcluded(month, mergedDisabledDatesIntervals, 'month');
  };
  this.calcYearMonthExcluded = function (value, mergedDisabledDatesIntervals, granularity) {
    if (mergedDisabledDatesIntervals.length === 0) return false;
    var _this$momentUtils6 = _this.momentUtils,
      getStartDate = _this$momentUtils6.getStartDate,
      getEndDate = _this$momentUtils6.getEndDate,
      isSameOrAfter = _this$momentUtils6.isSameOrAfter,
      isSameOrBefore = _this$momentUtils6.isSameOrBefore;
    for (var _iterator3 = _createForOfIteratorHelperLoose(mergedDisabledDatesIntervals), _step3; !(_step3 = _iterator3()).done;) {
      var interval = _step3.value;
      var intervalStart = interval[0],
        intervalEnd = interval[1];
      var valueStart = getStartDate(value, granularity);
      var valueEnd = getEndDate(value, granularity);
      var compareGranularity = _this.maxDetail === 'decade' ? 'year' : _this.maxDetail === 'year' ? 'month' : 'day';
      if (isSameOrBefore(intervalStart, valueStart, compareGranularity) && isSameOrAfter(intervalEnd, valueEnd, compareGranularity)) {
        return true;
      }
    }
    return false;
  };
  this.isYearExcluded = function (year, mergedDisabledDatesIntervals) {
    return _this.calcYearMonthExcluded(year, mergedDisabledDatesIntervals, 'year');
  };
  this._getSeperateDateStringFromRangeDateString = function (ds) {
    var _ds$split = ds.split(" " + _this.rangeConnecterFormat + " "),
      valueFrom = _ds$split[0],
      valueTo = _ds$split[1];
    valueFrom = valueFrom ? valueFrom.replace(/(\s*$)/g, '') : '';
    valueTo = valueTo ? valueTo.replace(/(^\s*)/g, '') : '';
    return [valueFrom, valueTo];
  };
  this._isValidFormatRangeDate = function (ds) {
    if (ds === '') return true;
    var _this$_getSeperateDat2 = _this._getSeperateDateStringFromRangeDateString(ds),
      valueFrom = _this$_getSeperateDat2[0],
      valueTo = _this$_getSeperateDat2[1];
    var isValidate = _this.momentUtils.isValidate;
    return isValidate(valueFrom) && isValidate(valueTo);
  };
  this._isValidFormatSingleDate = function (ds) {
    return _this.momentUtils.isValidate(ds);
  };
  this.doesRangeConludeRange = function (greaterRange, smallerRange, granularity) {
    if (granularity === void 0) {
      granularity = 'day';
    }
    var _this$momentUtils7 = _this.momentUtils,
      isBefore = _this$momentUtils7.isBefore,
      isAfter = _this$momentUtils7.isAfter;
    return isBefore(greaterRange[0], smallerRange[0], granularity) && isAfter(greaterRange[1], smallerRange[1], granularity);
  };
  this.momentUtils = momentGenerator(format, _granularity);
  this.rangeConnecterFormat = rangeConnecterFormat;
  this.format = format;
  this.singleDateStringLength = this.format.length;
  this.rangeDateStringLength = 2 * this.singleDateStringLength + this.rangeConnecterFormat.length + 2;
  this.maxDetail = maxDetail;
};
export var emptyFn = function emptyFn() {};
export function onDatepickerInputChange(event, isRangePicker, dpRangeConnecterFormat, dateSeparator, format) {
  if (dpRangeConnecterFormat === void 0) {
    dpRangeConnecterFormat = 'to';
  }
  if (dateSeparator === void 0) {
    dateSeparator = '/';
  }
  if (format === void 0) {
    format = DEFAULT_DATE_FORMAT;
  }
  var spaceLength = 2;
  var allowedLength = isRangePicker ? format.length * 2 + spaceLength + dpRangeConnecterFormat.length : format.length;
  var value = event.target.value;
  if (value.length > allowedLength) return value.substring(0, allowedLength);
  var stack = value.split('').filter(function (_char) {
    return !isNaN(Number(_char)) && _char !== ' ';
  });
  var separatorPos = [];
  var connectorPos = isRangePicker ? format.length : -1;
  var isDelete = event.nativeEvent.inputType === 'deleteContentBackward';
  var compositeFormat = isRangePicker ? format + " " + dpRangeConnecterFormat + " " + format : format;
  for (var i = 0; i < compositeFormat.length; i++) {
    if (compositeFormat[i] === dateSeparator) {
      separatorPos.push(i);
    }
  }
  var newStr = '';
  while (stack.length > 0) {
    newStr += stack.shift();
    var nextPos = newStr.length;
    if (separatorPos.indexOf(nextPos) !== -1) {
      if (!isDelete || stack.length !== 0) newStr += dateSeparator;
    }
    if (nextPos === connectorPos && stack.length !== 0) {
      newStr += " " + dpRangeConnecterFormat + " ";
    }
  }
  return newStr;
}
export function onTimepickerInputChange(event, inputType, hourTime) {
  var allowedLength = 2;
  var value = event.target.value;
  var curLength = event.target.value.length;
  if (value.length > allowedLength) return value.substring(0, allowedLength);
  if (inputType === TIMETYPE.MERIDIEM) {
    return value;
  } else {
    var tiemTypeKey = inputType === TIMETYPE.HOUR ? inputType + "-" + hourTime : inputType;
    var timeInterval = TIME_VALUE_INTERVAL_MAP.get(tiemTypeKey);
    if (Number(value) > timeInterval[1] || Number(value) < timeInterval[0] || isNaN(Number(value))) {
      return value.substring(0, curLength - 1);
    } else {
      return value;
    }
  }
}
export var DateCalculator = function DateCalculator(_format, momentGenerator, _rangeConnecterFormat, _granularity2, maxDetail) {
  var _this2 = this;
  if (_format === void 0) {
    _format = DEFAULT_DATE_FORMAT;
  }
  if (_rangeConnecterFormat === void 0) {
    _rangeConnecterFormat = 'to';
  }
  this.momentUtils = void 0;
  this.rangeConnecterFormat = void 0;
  this.dateValidator = void 0;
  this.format = void 0;
  this.maxDetail = void 0;
  this.mergeDisabledDatesIntervals = function (intervals, granularity) {
    var _this2$momentUtils = _this2.momentUtils,
      diff = _this2$momentUtils.diff,
      getStartDate = _this2$momentUtils.getStartDate,
      getEndDate = _this2$momentUtils.getEndDate;
    if (intervals.length === 0 || intervals.every(function (subArr) {
      return subArr.length === 0;
    })) {
      return [];
    }
    if (granularity === 'month') {
      var newIntervals = [];
      for (var _iterator4 = _createForOfIteratorHelperLoose(intervals), _step4; !(_step4 = _iterator4()).done;) {
        var interval = _step4.value;
        newIntervals.push([getStartDate(interval[0], 'month'), getEndDate(interval[1], 'month')]);
      }
      intervals = newIntervals;
    }
    intervals.sort(function (a, b) {
      return diff(b[0], a[0], 'day');
    });
    var mergedIntervals = [];
    for (var i = 0; i < intervals.length; i++) {
      var L = intervals[i][0],
        R = intervals[i][1];
      if (mergedIntervals.length === 0 ||
      //here should be one rather than 0,
      //because we need to merge single day intervals together
      diff(mergedIntervals[mergedIntervals.length - 1][1], L, 'day') > 1) {
        mergedIntervals.push([L, R]);
      } else {
        mergedIntervals[mergedIntervals.length - 1][1] = diff(mergedIntervals[mergedIntervals.length - 1][1], R, 'day') > 0 ? R : mergedIntervals[mergedIntervals.length - 1][1];
      }
    }
    return mergedIntervals;
  };
  this.calculateDateRange = function (value, detail) {
    var _this2$momentUtils2 = _this2.momentUtils,
      getStartDate = _this2$momentUtils2.getStartDate,
      getEndDate = _this2$momentUtils2.getEndDate;
    return [getStartDate(value, detail), getEndDate(value, detail)];
  };
  this.calculateTileClasses = function (_temp2) {
    var _ref2 = _temp2 === void 0 ? {} : _temp2,
      selectRange = _ref2.selectRange,
      value = _ref2.value,
      valueType = _ref2.valueType,
      date = _ref2.date,
      dateType = _ref2.dateType,
      hover = _ref2.hover,
      keyboardNavDate = _ref2.keyboardNavDate,
      startDate = _ref2.startDate,
      endDate = _ref2.endDate,
      isNeighboringDate = _ref2.isNeighboringDate;
    var className = 'ap-tile';
    var classes = [className];
    var titleDate = date;
    var selectValue = value;
    var now = new Date();
    var currentDetail = dateType;
    var _this2$momentUtils3 = _this2.momentUtils,
      isSame = _this2$momentUtils3.isSame,
      addDate = _this2$momentUtils3.addDate,
      getStartDate = _this2$momentUtils3.getStartDate,
      getEndDate = _this2$momentUtils3.getEndDate;
    var _this2$dateValidator = _this2.dateValidator,
      isDayInRange = _this2$dateValidator.isDayInRange,
      doesRangeConludeRange = _this2$dateValidator.doesRangeConludeRange;
    //As the start date might include last month's date in the view of month
    //e.g. 27 28 29 1  2  3  4
    //      5  6  7 8  9 10 11
    //     12 13 14 15 16 17...
    //in this case, start date is 27
    //So, add 15 days and get the mid date of
    if (dateType === 'day') {
      var midDate = addDate(startDate, 15, 'day');
      startDate = getStartDate(midDate, 'month');
      endDate = getEndDate(midDate, 'month');
    }
    var currentPanelRange = [startDate, endDate];
    var isInsideCurrentPanel = isDayInRange(date, currentPanelRange[0], currentPanelRange[1], dateType, false);
    classes.push('ap-normal');
    if (!titleDate) {
      return classes;
    }
    if (!(titleDate instanceof Array) && !dateType) {
      throw new Error('getTileClasses(): Unable to get tile activity classes because one or more required arguments were not passed.');
    }
    var tileRange = titleDate instanceof Array ? titleDate : _this2.calculateDateRange(titleDate, currentDetail);
    if (isDayInRange(now, tileRange[0], tileRange[1], dateType, false)) {
      classes.push('ap-tile-now');
    }
    if (isDayInRange(keyboardNavDate, tileRange[0], tileRange[1], dateType, false)) {
      classes.push('ap-tile-key-nav');
    }
    if (!selectValue) {
      return classes;
    }
    if (!(selectValue instanceof Array) && !valueType) {
      throw new Error('getTileClasses(): Unable to get tile activity classes because one or more required arguments were not passed.');
    }

    //from value property
    //get range make day 00:00:00 - > 23:59:59
    var onlySelectOne = selectValue instanceof Date || selectValue.length === 1;
    var selectedRange = selectValue instanceof Array ? selectValue : _this2.calculateDateRange(selectValue, valueType);
    if (selectedRange.length === 1) {
      selectedRange = _this2.calculateDateRange(selectValue[0], valueType);
    }

    // Double single manually input a disabled date

    if (!selectRange) {
      if (selectValue instanceof Array) {
        if (isSame(selectValue[0], titleDate)) {
          classes.push('ap-tile-active');
        }
        if (isDayInRange(titleDate, selectValue[0], selectValue[1], dateType, false)) {
          classes.push('ap-tile-active');
        }
      }
    } else {
      if (isDayInRange(titleDate, selectValue[0], selectValue[1], dateType, false)) {
        classes.push('ap-tile-active');
      }
    }
    //open interval
    if (doesRangeConludeRange(selectedRange, tileRange)) {
      classes.push('ap-tile-within');
    }
    if (selectRange && (hover || keyboardNavDate) && onlySelectOne) {
      var hoverRange = _this2.calculateDateRange(hover || keyboardNavDate, dateType);
      var hoverOnSelect = isSame(hoverRange[0], selectedRange[0], dateType) && isSame(hoverRange[1], selectedRange[1], dateType);
      if (!hoverOnSelect) {
        hoverRange = hoverRange.concat(selectedRange).sort(function (a, b) {
          return a.getTime() - b.getTime();
        });
        hoverRange = [hoverRange[0], hoverRange[3]];
        if (isDayInRange(titleDate, hoverRange[0], hoverRange[1], dateType, false) && isInsideCurrentPanel) {
          classes.push('ap-tile-selected-tile');
        }
        if (!isNeighboringDate) {
          if (doesRangeConludeRange(hoverRange, tileRange, dateType)) {
            classes.push('ap-tile-hover-middle');
          } else if (isSame(tileRange[0], hoverRange[0], dateType) && isSame(tileRange[0], hoverRange[1], dateType)) {
            classes.push('ap-tile-hoverBothEnds');
          } else if (isSame(tileRange[0], hoverRange[0], dateType)) {
            classes.push('ap-tile-hoverStart');
          } else if (isSame(tileRange[0], hoverRange[1], dateType)) {
            classes.push('ap-tile-hoverEnd');
          }
        }
      }
    }
    var isRangeStart = isDayInRange(selectedRange[0], tileRange[0], tileRange[1], dateType, false);
    var isRangeEnd = isDayInRange(selectedRange[1], tileRange[0], tileRange[1], dateType, false);
    var hasNoHoverEffect = classes.indexOf('ap-tile-hoverStart') === -1 && classes.indexOf('ap-tile-hoverEnd') === -1;
    if (isRangeStart && isRangeEnd && hasNoHoverEffect) {
      classes.push('ap-tile-rangeBothEnds');
    } else if (isRangeStart) {
      classes.push('ap-tile-rangeStart');
    } else if (isRangeEnd) {
      classes.push('ap-tile-rangeEnd');
    }
    return classes;
  };
  this.calculateStartAndEndDateOfView = function (view, currentDate) {
    var _this2$momentUtils4 = _this2.momentUtils,
      getStartDate = _this2$momentUtils4.getStartDate,
      getEndDate = _this2$momentUtils4.getEndDate;
    var _startDate = getStartDate(currentDate, view);
    var _endDate = getEndDate(currentDate, view);
    return [_startDate, _endDate];
  };
  this.calculateDatestringFromDateValues = function (valueFrom, valueTo, selectRange) {
    if (selectRange === void 0) {
      selectRange = false;
    }
    var rangeConnecterFormat = _this2.rangeConnecterFormat,
      momentUtils = _this2.momentUtils;
    var format = momentUtils.format;
    if (!valueFrom) return '';
    if (!selectRange && valueFrom) return format(valueFrom);
    var result = [];
    if (valueFrom) {
      result.push(format(valueFrom));
    }
    if (valueTo) {
      result.push(format(valueTo));
    }
    return result.join(" " + rangeConnecterFormat + " ");
  };
  this.calculateDateValuesFromDateString = function (ds) {
    var momentUtils = _this2.momentUtils;
    var getFixedDate = momentUtils.getFixedDate;
    var formatLength = _this2.format.length;
    var singleDateStringLength = formatLength;
    var rangeDateStringLength = 2 * formatLength + _this2.rangeConnecterFormat.length + 2;
    if (ds.length === rangeDateStringLength) {
      if (_this2.dateValidator._isValidFormatRangeDate(ds)) {
        var dsList = _this2.dateValidator._getSeperateDateStringFromRangeDateString(ds);
        return dsList.map(function (d) {
          return getFixedDate(d);
        });
      } else {
        return [];
      }
    } else if (ds.length === singleDateStringLength) {
      if (_this2.dateValidator._isValidFormatSingleDate(ds)) {
        return getFixedDate(ds);
      } else {
        return null;
      }
    } else if (ds === '') {
      return undefined;
    } else {
      return null;
    }
  };
  this.calculateInitActiveDate = function (detail, value) {
    var activeStartDateLeft = null;
    var activeStartDateRight = null;
    var _this2$momentUtils5 = _this2.momentUtils,
      getStartDate = _this2$momentUtils5.getStartDate,
      getNow = _this2$momentUtils5.getNow,
      addDate = _this2$momentUtils5.addDate;
    if (!value) {
      var anchorDay = getNow();
      activeStartDateLeft = getStartDate(anchorDay, detail);
      activeStartDateRight = getStartDate(addDate(anchorDay, 1, detail), detail);
    } else if (value instanceof Array) {
      var _anchorDay = value[0] || getNow();
      activeStartDateLeft = getStartDate(_anchorDay, detail);
      activeStartDateRight = getStartDate(addDate(activeStartDateLeft, 1, detail), detail);
    } else if (!(value instanceof Array)) {
      var _anchorDay2 = value || getNow();
      activeStartDateLeft = getStartDate(_anchorDay2, detail);
      activeStartDateRight = getStartDate(addDate(_anchorDay2, 1, detail), detail);
    }
    return [activeStartDateLeft, activeStartDateRight];
  };
  this.momentUtils = momentGenerator(_format, _granularity2);
  this.rangeConnecterFormat = _rangeConnecterFormat;
  this.maxDetail = maxDetail;
  this.dateValidator = new DateValidator(_format, momentGenerator, _rangeConnecterFormat, _granularity2, maxDetail);
  this.format = _format;
}

//Similar as solution of leetcode#56 merge-intervals
;